package com.kinoshazam.uiKit.components.textLabel

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import com.kinoshazam.uiKit.theme.Medium

data class TextLabelState(
    val text: CharSequence,
    val color: Color = Color.Black,
    val textStyle: TextStyle = Medium,
    val maxLines: Int = Int.MAX_VALUE,
    val textAlign: TextAlign? = null,
)
